import React, { useContext } from "react";
import credentialOne from "../../../assets/images/Li.png";
import credentialTwo from "../../../assets/images/L2.png";
import { FeatureCard } from "../../../global/components/FeatureCard/FeatureCard";
import useSWR from "swr";
import { fetcher } from "../../../lib/apiConstants";
import { LoginContext } from "../../../lib/loginContext";

export const LicenseFeatureContent = () => {
  const { data: products, isLoading: productsLoading } = useSWR(
    "products/",
    fetcher
  );
  const { isLoggedIn } = useContext(LoginContext);
  return (
    <>
      <div className="cloud-bg flex justify-center items-center">
        <p className="bg-text text-center">License & Capacity Management</p>
      </div>
      {/* {isLoggedIn && (
        <div className="max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 mt-4 md:mt-8 lg:mt-16">
          <DownloadSection
            title="Cut Sheet"
            description="Learn about 2.0 Mobile Credential features"
            backgroundImage={CatalogueBackground}
            buttonText="Download Now"
            linkField="others_link"
            products={products || []}
            isLoading={productsLoading}
            filterBySlug="13-5-mhz-mifare-reader"
            showOnlyFirst={true}
          />
        </div>
      )} */}
      <div className="max-w-[1200px] max-xl:max-w-full my-16 mx-auto max-xl:mx-6 py-4 md:py-6 lg:py-16">
        <FeatureCard
          image={credentialOne}
          label="Scalable License Architecture & Enterprise Access Control"
          description="The system delivers three tiered license models — Advantage, Professional, and Corporate — with flexible deployment across On Premise, RMC, RMC Plus, Cloud, and Virtual environments. Scale from 4 to 65,535 doors with volume-based pricing, while premium features like REST API, Mobile App, Single Sign-On, and Badge management activate on-demand. The license management interface enables seamless updates, model upgrades, and node type configuration (Manager/Worker), supporting OSDP devices, Trilogy locksets, directory extensions, and mobile credentials. Both annual and lifetime licensing options deliver cost-effective pathways for organizations of any size to deploy precisely configured security infrastructure."
          imageLeft={true}
          hideLine={true}
        />
        <FeatureCard
          image={credentialTwo}
          label="Capacity Monitoring & Resource Control"
          description="The capacity dashboard delivers real-time visibility into system resource utilization across all licensed components — tracking total limits, current usage, and available capacity. Administrators monitor critical metrics including 15,000 access persons, 120,000 credentials, 200,000 transaction logs, and comprehensive scheduling capabilities. Resource tracking spans Dashboard operations, Access Control management, Maintenance functions, Device configurations, External integrations, and Web User administration — enabling data-driven decisions for license optimization, capacity planning, and strategic upgrades based on actual consumption patterns."
          imageLeft={false}
          hideLine={true}
        />
      </div>
    </>
  );
};
